import React from "react";
import "./AboutStory.css";
import BusinessIcon from "@mui/icons-material/Business";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import aboutstory from "../img/New/aboutstory.png";

const AboutStory = () => {
  return (
    <section className="oglitz-about-story-premium">
      <div className="oglitz-about-story-wrapper">
        {/* LEFT – MAIN STORY */}
        <div className="oglitz-about-story-main">
          {/* COMPANY INTRO */}
          <div className="oglitz-about-story-block">
            <div className="oglitz-about-story-heading">
              <BusinessIcon />
              <h2>About Oglitz Software</h2>
            </div>

            <p>
              <strong>Oglitz Software</strong> is a forward-thinking global IT
              services company delivering innovative, secure, and scalable
              digital solutions. Since 2021, we have been helping businesses
              transform ideas into reliable technology-driven products.
            </p>

            <p>
              With a strong global delivery mindset and deep technical
              expertise, we empower organizations to stay competitive in an
              evolving digital-first world.
            </p>
          </div>

          {/* MISSION */}
          <div className="oglitz-about-story-block">
            <div className="oglitz-about-story-heading">
              <RocketLaunchIcon />
              <h2>Our Mission & Approach</h2>
            </div>

            <p>
              Our mission is to help organizations achieve sustainable growth
              through modern engineering practices and emerging technologies. We
              focus on building long-term partnerships rather than short-term
              engagements.
            </p>

            <p>
              Our dedicated engagement model ensures transparency,
              collaboration, and measurable value delivery across the entire
              development lifecycle.
            </p>
          </div>
          {/* LEFT SIDE VISUAL FILLER */}
          <div className="oglitz-about-story-visual">
            <img
              src={aboutstory}
              alt="Oglitz team collaboration"
              loading="lazy"
            />
          </div>
        </div>

        {/* RIGHT – BRAND PHILOSOPHY */}
        <div className="oglitz-about-story-highlight">
          <div className="oglitz-about-story-heading">
            <AutoAwesomeIcon />
            <h2>The Meaning of Oglitz</h2>
          </div>

          <p className="highlight-intro">
            Oglitz represents more than a name — it reflects our philosophy and
            commitment to excellence.
          </p>

          <ul>
            <li>
              <strong>O (ॐ):</strong> Symbolizes unity, completeness, and
              universal connection.
            </li>
            <li>
              <strong>Glitz:</strong> Represents brilliance, sophistication, and
              technological excellence.
            </li>
          </ul>

          <div className="highlight-footer">
            Delivering innovation with clarity, precision, and long-term vision.
          </div>

          {/* WHY CHOOSE OGLITZ */}
          <div className="oglitz-about-story-why">
            <h3 className="oglitz-about-story-why-title">
              Why Businesses Choose Oglitz
            </h3>

            <ul className="oglitz-about-story-why-list">
              <li>
                <span>✔</span>
                Dedicated development teams with global delivery experience
              </li>
              <li>
                <span>✔</span>
                Transparent communication & agile execution model
              </li>
              <li>
                <span>✔</span>
                Secure, scalable, and future-ready technology solutions
              </li>
              <li>
                <span>✔</span>
                Long-term partnership mindset, not project-only delivery
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
